import { PrivacyLaw } from '../types';

export const dpiaLaws: PrivacyLaw[] = [
  {
    id: 'gdpr',
    name: 'GDPR (EU)',
    category: 'global',
    description: 'Required for high-risk processing under Article 35 of GDPR',
    requiresDpia: true
  },
  {
    id: 'uk_gdpr',
    name: 'UK GDPR',
    category: 'global',
    description: 'Required for high-risk processing under UK data protection law',
    requiresDpia: true
  },
  {
    id: 'cpra',
    name: 'CPRA (California)',
    category: 'usState',
    description: 'Required for high-risk processing under California Privacy Rights Act',
    requiresDpia: true
  },
  {
    id: 'vcdpa',
    name: 'VCDPA (Virginia)',
    category: 'usState',
    description: 'Required for processing activities that present heightened risks under Virginia Consumer Data Protection Act § 59.1-576',
    requiresDpia: true
  },
  {
    id: 'cpa',
    name: 'CPA (Colorado)',
    category: 'usState',
    description: 'Required for data processing that presents heightened risk of harm under Colorado Privacy Act § 6-1-1309',
    requiresDpia: true
  },
  {
    id: 'pipl',
    name: 'PIPL (China)',
    category: 'global',
    description: 'Required for personal information processing under PIPL Article 55',
    requiresDpia: true
  },
  {
    id: 'lgpd',
    name: 'LGPD (Brazil)',
    category: 'global',
    description: 'Required for processing that may pose risks under LGPD Article 38',
    requiresDpia: true
  }
];